import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createNewCompany, getCompanyInfo, updateCompanyInfo } from "../thunks/companyThunks";
import { CompanyInfoDTO, GetCompanyInfoResponse } from "../../models/CompanyInfo.model";
import { CreateNewCompanyResponse } from '../../models/Company.model';


interface CompanyState {
  loading: boolean;
  error: string | null;
  errorUpdate: string | null;
  updateLoading: boolean;
  createError: string | null;
  companyInfo: CompanyInfoDTO | null;
  createNewCompanyResponse : CreateNewCompanyResponse | null;
}

const initialState: CompanyState = {
  loading: false,
  error: null,
  errorUpdate: null,
  updateLoading: false,
  createError: null,
  companyInfo: null,
  createNewCompanyResponse: null,
};
const CompanyInfoSlice = createSlice({
  name: "companyInfo",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.error = null;
    },
    clearCreateNewCompanyResponse: (state) => {
      state.createNewCompanyResponse = null;
    },

    resetCreateState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // יצירת חברה חדשה
      .addCase(createNewCompany.pending, (state) => {
        state.loading = true;
        state.createError = null;
      })
      .addCase(
        createNewCompany.fulfilled,
        (state, action: PayloadAction<CreateNewCompanyResponse>) => {
          state.loading = false;
          state.createError = null;
          state.createNewCompanyResponse = action.payload;
        }
      )
      .addCase(createNewCompany.rejected, (state, action) => {
        state.loading = false;
        state.createError = action.payload as string;
      })

      // קבלת מידע על חברה
      .addCase(getCompanyInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getCompanyInfo.fulfilled,
        (state, action: PayloadAction<GetCompanyInfoResponse>) => {
          state.loading = false;
          state.error = null;
          state.companyInfo = action.payload.company;
        }
      )
      .addCase(getCompanyInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(updateCompanyInfo.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(
        updateCompanyInfo.fulfilled,
        (state, action) => {
          state.updateLoading = false;
          state.error = null;
          const req = action.meta.arg;
          state.companyInfo = {
            company_IdentType: req.identType,
            company_Ident: req.ident,
            company_BookingName: req.bookingName,
            company_BizName: req.bizName,
            company_Address: req.address,
            company_City: req.city,
            company_EMail: req.eMail,
            company_Phone: req.phone,
            company_Website: req.website,
            company_Base64Logo: req.base64Logo,
            company_Base64Sign: req.base64Sign,
            company_IsActive: true
          };
        
        }
      )
      .addCase(updateCompanyInfo.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError,resetCreateState } =
  CompanyInfoSlice.actions;

export default CompanyInfoSlice.reducer;
